import type { Router, RouteRecordRaw } from 'vue-router'
import { PageName } from 'shared/lib/types/app/pages'

export const moduleRoute: RouteRecordRaw = {
  path: 'tasks',
  name: PageName.TASKS_PAGE,
  component: () => import('./pages/TasksIndex.vue'),
  redirect: { name: 'AllTasks' },
  meta: {
    breadcrumbName: 'Все задания',
  },
  children: [
    {
      path: ':uid',
      name: PageName.ALL_TASKS,
      component: () => import('./pages/AllTasksPage.vue'),
      meta: {},
    },
    {
      path: ':uid/detail/:taskId',
      name: PageName.TASK_DETAILS,
      component: () => import('./pages/TaskDetailPage.vue'),
      meta: {
        breadcrumbName: 'Задание №',
      },
    },
  ],
}

export default (router: Router) => {
  router.addRoute(PageName.MAIN_LAYOUT, moduleRoute)
}
